var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.user)?_c('Navbar',{on:{"toggle-drawer":function($event){_vm.$refs.drawer.drawer = !_vm.$refs.drawer.drawer}}}):_vm._e(),(_vm.isAdmin)?_c('Drawer',{ref:"drawer"}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }